<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '48',
	},
	height: {
		type: String,
		default: '48',
	},
	strokeWidth: {
		type: String,
		default: '1',
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="user-attendee">
      <path
        id="Icon"
        d="M13.4568 14.0187C12.9839 13.8512 11.7043 13.8512 10.5421 13.8512H6.37828C5.2161 13.8512 4.63501 13.8512 4.16217 14.0187C3.09756 14.3959 2.26445 15.3687 1.94151 16.6119C1.85432 16.9476 1.82013 17.3299 1.80672 17.883C1.79581 18.3329 1.79036 18.5579 1.87952 18.7382C1.95672 18.8943 2.08824 19.0274 2.24436 19.1074C2.42465 19.1998 2.65993 19.1998 3.13049 19.1998H14.7059M18.037 17.4718V17.9655M18.037 15.2501V15.7438M18.037 13.0284V13.5221M12.624 8.70838C12.624 10.867 10.853 12.6169 8.66837 12.6169C6.48374 12.6169 4.71275 10.867 4.71275 8.70838C4.71275 6.54973 6.48374 4.7998 8.66837 4.7998C10.853 4.7998 12.624 6.54973 12.624 8.70838ZM20.6685 19.1998H14.1563C13.6199 19.1998 13.3518 19.1998 13.1469 19.0989C12.9667 19.0102 12.8202 18.8685 12.7284 18.6944C12.624 18.4963 12.624 18.2371 12.624 17.7187V17.1169C13.5496 17.1169 14.2999 16.3916 14.2999 15.4969C14.2999 14.6022 13.5496 13.8769 12.624 13.8769V13.2752C12.624 12.7568 12.624 12.4976 12.7284 12.2995C12.8202 12.1254 12.9667 11.9837 13.1469 11.895C13.3518 11.7941 13.6199 11.7941 14.1563 11.7941L20.6685 11.7941C21.2048 11.7941 21.473 11.7941 21.6779 11.895C21.8581 11.9837 22.0046 12.1254 22.0964 12.2995C22.2008 12.4976 22.2008 12.7568 22.2008 13.2752V13.8769C21.2752 13.8769 20.5248 14.6022 20.5248 15.4969C20.5248 16.3916 21.2752 17.1169 22.2008 17.1169V17.7187C22.2008 18.2371 22.2008 18.4963 22.0964 18.6944C22.0046 18.8685 21.8581 19.0102 21.6779 19.0989C21.473 19.1998 21.2048 19.1998 20.6685 19.1998Z"
        :stroke="iconColor"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
